<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav :selectedLanguage="selectedLanguage" page="blog" :gotodownload="gotodownload" :apk="apk" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="blog-article">
            <Breadcrumb />
            <header class="blog-header">
              <h1>The Secret Settings That Make GBWhatsApp More Private Than Ever</h1>
            </header>

            <div class="blog-content">
              <div class="blog-intro">
                <img src="@/assets/blog-2.webp" alt="The Secret Set of GB cover" class="blog-featured-image">
                <p>In a world where online presence feels constant, privacy is more important than ever. <a class="jump-url" href="https://gbwhataps.com/download/">GBWhatsApp</a> offers a range of hidden settings that let users <strong>control who sees their activity, hide personal info, and enjoy a private messaging experience</strong> beyond the standard WhatsApp options.</p>
              </div>

              <div class="content-section">
                <h2>Hide Last Seen and Online Status</h2>
                <p>GBWhatsApp allows you to freeze your last seen or hide your online status entirely. Unlike the official app, you can <strong>browse, chat, and reply without anyone knowing you’re active,</strong> giving you a layer of privacy that feels effortless.</p>
              </div>

              <div class="content-section">
                <h2>Custom Privacy for Specific Contacts</h2>
                <p>With GBWhatsApp, you can <strong>customize privacy for individual contacts.</strong> Decide who can see your profile picture, status, or last seen. This selective visibility ensures that your personal life remains separate from work or casual contacts.</p>
              </div>

              <div class="content-section">
                <h2>Disable Read Receipts and Blue Ticks</h2>
                <p>Another simple but powerful setting is the ability to <strong>disable blue ticks and read receipts.</strong> Read messages at your pace without making others feel ignored, maintaining control over how and when you respond.</p>
              </div>

              <div class="content-section">
                <h2>Hide Typing and Recording Indicators</h2>
                <p>GBWhatsApp lets you <strong>hide typing or recording notifications,</strong> giving you the ability to compose messages privately. This small adjustment makes conversations feel less pressured and more discreet.</p>
              </div>

              <div class="content-section">
                <h2>Lock Individual Chats for Extra Security</h2>
                <p>For sensitive conversations, GBWhatsApp allows users to <strong>lock individual chats</strong> using a PIN or fingerprint. Even if someone accesses your phone, your private messages stay hidden and secure.</p>
              </div>

              <div class="content-section">
                <h2>Final Thoughts: Privacy Tailored to You</h2>
                <p>GBWhatsApp’s secret settings make privacy <strong>flexible and personal.</strong> You can control exactly who sees your activity, when, and how, turning your messaging app into a space that respects your boundaries. For anyone looking to <strong>take back control of their online presence,</strong> exploring these settings transforms everyday messaging into a private, stress-free experience.</p>
              </div>
            </div>

          </article>
        </main>
      </div>
    </div>
  </div>

  <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    Download GBWhatsapp APK
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';

export default {
  name: 'Blog2',
  components: {
    HeadNav,
    Breadcrumb,
  },
  data() {
    return {
      pageName: 'blog-2',
      selectedLanguage: 'en',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    goto(name) {
      this.$router.push({
        name: `${name}`
      });
    },
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhataps.com',
          appName: appname || 'GB_gbwhataps.com',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    gotoHome(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<style scoped>
.blog-article {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.blog-header {
  text-align: center;
  margin-bottom: 40px;
}

.blog-header h1 {
  font-size: 2.5em;
  color: #25D366;
  margin-bottom: 20px;
  line-height: 1.2;
}

.blog-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  color: #666;
  font-size: 0.9em;
}

.blog-meta span {
  padding: 5px 15px;
  background: #f5f5f5;
  border-radius: 20px;
}

.blog-content {
  line-height: 1.8;
  font-size: 1.1em;
}

.blog-intro {
  margin-bottom: 40px;
}

.blog-featured-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  border-radius: 10px;
  margin: 0 auto 30px;
  display: block;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.content-section {
  margin-bottom: 35px;
}

.content-section h2 {
  color: #25D366;
  font-size: 1.8em;
  margin-bottom: 15px;
  border-left: 4px solid #25D366;
  padding-left: 15px;
}

.content-section p {
  margin-bottom: 15px;
  color: #333;
}

.content-section.conclusion {
  padding: 25px;
  border-radius: 10px;
  font-style: italic;
  font-size: 1.1em;
}

@media (max-width: 768px) {
  .blog-article {
    padding: 15px;
  }
  .blog-header h1 {
    font-size: 2em;
  }
  .content-section h2 {
    font-size: 1.5em;
  }
}
</style>

